<template>
  <div class="personnel-ledger-view">
    <CCard class="ledger-card ledger-card--toolbar border-0 shadow-sm mb-3">
      <CCardBody class="py-3">
        <CRow class="align-items-center">
          <CCol cols="12" lg="6" class="mb-2 mb-lg-0">
            <nav class="ledger-breadcrumb text-muted small mb-1" aria-label="breadcrumb">
              Personnel <span class="ledger-breadcrumb-sep">/</span> Ledger
              <template v-if="ledgerProfile.name">
                <span class="ledger-breadcrumb-sep">—</span>
                <span class="text-dark font-weight-bold">{{ ledgerProfile.name }}</span>
              </template>
            </nav>
          </CCol>
          <CCol cols="12" lg="6" class="text-lg-right ledger-toolbar-actions">
           <!-- <CButton
              v-if="config.getPermission('personnel_ledger').view"
              size="sm"
              color="info"
              variant="outline"
              class="mr-2 mb-2"
              @click="viewPayment()"
            >
              <i class="fa fa-clock-o mr-1" aria-hidden="true"></i>
              Deduction history
            </CButton> -->
            <CButton
              v-if="config.getPermission('personnel_ledger').download"
              size="sm"
              color="primary"
              variant="outline"
              class="mr-2 mb-2"
              @click="download()"
            >
              <i class="fa fa-download mr-1" aria-hidden="true"></i>
              Download
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard
      v-for="(item, key) in dataLedgerInfo"
      :key="'profile-' + key"
      class="ledger-card border-0 shadow-sm mb-3"
    >
      <CCardBody class="py-4">
        <CRow class="align-items-stretch">
          <CCol cols="12" md="4" lg="3" class="mb-3 mb-md-0">
            <div class="d-flex align-items-center">
              <div class="ledger-avatar mr-3" aria-hidden="true">
                {{ ledgerAvatarInitials(item) }}
              </div>
              <div>
                <h4 class="mb-1 text-dark font-weight-bold ledger-emp-name">
                  {{ item.employee_name }}
                </h4>
                <div class="text-muted small mb-2">{{ item.personnel_type }}</div>
                <CBadge
                  v-if="item.status"
                  class="ledger-status-badge text-uppercase"
                  :color="statusBadgeColor(item.status)"
                >
                  {{ item.status }}
                </CBadge>
              </div>
            </div>
          </CCol>
          <CCol cols="12" md="8" lg="9">
            <CRow class="ledger-stat-grid">
              <CCol cols="6" sm="4" lg="2" class="mb-2">
                <div class="ledger-stat-card">
                  <div class="ledger-stat-label">CA balance</div>
                  <div class="ledger-stat-value">
                    {{ item.personnel_ledger_CAB | number_format("currency") }}
                  </div>
                </div>
              </CCol>
              <CCol cols="6" sm="4" lg="2" class="mb-2">
                <div class="ledger-stat-card">
                  <div class="ledger-stat-label">Charges balance</div>
                  <div class="ledger-stat-value">
                    {{ item.personnel_ledger_CB | number_format("currency") }}
                  </div>
                </div>
              </CCol>
              <CCol cols="6" sm="4" lg="2" class="mb-2">
                <div class="ledger-stat-card">
                  <div class="ledger-stat-label">Other deductions</div>
                  <div class="ledger-stat-value">
                    {{ item.personnel_ledger_OtherDeductionsBalance | number_format("currency") }}
                  </div>
                </div>
              </CCol>
              <CCol cols="6" sm="4" lg="2" class="mb-2">
                <div class="ledger-stat-card">
                  <div class="ledger-stat-label">SSS loan balance</div>
                  <div class="ledger-stat-value">
                    {{ item.personnel_ledger_SSSBalance | number_format("currency") }}
                  </div>
                </div>
              </CCol>
              <CCol cols="6" sm="4" lg="2" class="mb-2">
                <div class="ledger-stat-card">
                  <div class="ledger-stat-label">Pag-IBIG loan balance</div>
                  <div class="ledger-stat-value">
                    {{ item.personnel_ledger_PagibigBalance | number_format("currency") }}
                  </div>
                </div>
              </CCol>
              <CCol cols="6" sm="4" lg="2" class="mb-2">
                <div class="ledger-stat-card ledger-stat-card--primary">
                  <div class="ledger-stat-label">Total balance</div>
                  <div class="ledger-stat-value ledger-stat-value--inverse">
                    {{ item.personnel_ledger_Total | number_format("currency") }}
                  </div>
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard class="ledger-card ledger-card--filters border-0 shadow-sm mb-3">
      <CCardBody class="py-3 ledger-filters-body">
        <CRow class="align-items-end">
          <CCol cols="12" md="auto" class="mb-3 mb-md-0">
            <label class="ledger-field-label">From</label>
            <div class="d-flex align-items-center ledger-date-wrap">
              <Datepicker
                input-class="form-control ledger-datepicker"
                wrapper-class="ledger-datepicker-root"
                v-model="date_from"
              />
              <i class="fa fa-calendar text-muted ml-2" aria-hidden="true"></i>
            </div>
          </CCol>
          <CCol cols="12" md="auto" class="mb-3 mb-md-0">
            <label class="ledger-field-label">To</label>
            <div class="d-flex align-items-center ledger-date-wrap">
              <Datepicker
                input-class="form-control ledger-datepicker"
                wrapper-class="ledger-datepicker-root"
                v-model="date_to"
              />
              <i class="fa fa-calendar text-muted ml-2" aria-hidden="true"></i>
            </div>
          </CCol>
          <CCol cols="12" md="auto" class="mb-3 mb-md-0 pr-md-2">
            <CButton size="sm" color="primary" class="ledger-filter-btn px-4" @click="filterList">
              <i class="fa fa-filter mr-1" aria-hidden="true"></i>
              Filter
            </CButton>
          </CCol>
          <CCol cols="12" md>
            <label class="ledger-field-label">Search</label>
            <CInput
              v-model.trim="searchQuery"
              placeholder="Search type, amount, date, remarks…"
              class="mb-0 ledger-search-input"
            />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard class="ledger-card ledger-card--tabs border-0 shadow-sm mb-3">
      <CCardBody class="py-2 px-3">
        <div class="ledger-type-tabs" role="tablist">
          <button
            v-for="tab in entryTypeTabs"
            :key="tab.value"
            type="button"
            class="ledger-type-tab"
            :class="{ 'ledger-type-tab--active': dataParams.entry_type === tab.value }"
            role="tab"
            :aria-selected="dataParams.entry_type === tab.value"
            @click="dataParams.entry_type = tab.value"
          >
            {{ tab.label }}
          </button>
        </div>
      </CCardBody>
    </CCard>

    <CCard class="ledger-card border-0 shadow-sm mb-3">
      <CCardBody class="pt-3 pb-2">
        <div class="ledger-section-head">
          <div class="d-flex align-items-center flex-wrap">
            <span class="ledger-section-title">Entries</span>
            <span class="ledger-count-badge">{{ ledgerEntryRows.length }}</span>
          </div>
          <div class="d-flex align-items-center flex-wrap ledger-section-head-actions">
            <!-- <span class="ledger-section-total ledger-section-total--entries mr-md-2 mb-2 mb-md-0">
              {{ entriesTotalFormatted }}
            </span> -->
            <CButton
              v-if="config.getPermission('personnel_ledger').create"
              size="sm"
              color="success"
              class="ledger-section-action-btn"
              @click="addModal()"
            >
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Add entry
            </CButton>
          </div>
        </div>
        <div class="table-responsive-sm table-responsive-md ledger-table-wrap">
          <CDataTable
            pagination
            :loading="isLoading"
            :items="ledgerEntryRows"
            :fields="fields"
            hover
            outlined
            itemsperPage="10"
            itemsPerPageSelect
            class="ledger-data-table"
          >
            <template #entry_type="{ item }">
              <td class="align-middle">
                <CBadge class="ledger-type-badge" :color="entryTypeBadgeColor(item.entry_type_holder)">
                  {{ item.entry_type }}
                </CBadge>
              </td>
            </template>
            <template #amount="{ item }">
              <td class="align-middle font-weight-bold ledger-amount-entry">
                {{ entryAmountDisplay(item) }}
              </td>
            </template>
            <template #action="{ item }">
              <td class="align-middle ledger-action-cell" style="min-width: 6rem">
                <CDropdown
                  v-if="hasLedgerRowActionsPermission"
                  toggler-text="Select"
                  size="sm"
                  color="secondary"
                  class="ledger-row-actions"
                  placement="bottom-end"
                  :custom-popper-options="ledgerActionDropdownPopperOptions"
                  add-menu-classes="dropdown-menu-right"
                >
                  <CDropdownItem
                    v-if="config.getPermission('personnel_ledger').update"
                    :disabled="hasPayrollReference(item)"
                    @click="updateModal(item)"
                  >
                    <i class="fa fa-pencil-square-o mr-1" aria-hidden="true"></i>
                    Update
                  </CDropdownItem>
                  <CDropdownItem
                    v-if="config.getPermission('personnel_ledger').delete"
                    :disabled="hasPayrollReference(item)"
                    @click="deleteItem(item)"
                  >
                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                    Delete
                  </CDropdownItem>
                </CDropdown>
              </td>
            </template>
          </CDataTable>
        </div>
      </CCardBody>
    </CCard>

    <CCard class="ledger-card border-0 shadow-sm mb-4">
      <CCardBody class="pt-3 pb-2">
        <CRow class="ledger-stat-grid ledger-deduction-payment-row mb-3">
       
          <CCol cols="6" sm="4" lg="2" class="mb-2">
            <div class="ledger-stat-card">
              <div class="ledger-stat-label">Charges payment</div>
              <div class="ledger-stat-value">
                {{ deductionPaymentSummary.charges }}
              </div>
            </div>
          </CCol>
          <CCol cols="6" sm="4" lg="2" class="mb-2">
            <div class="ledger-stat-card">
              <div class="ledger-stat-label">SSS loan payment</div>
              <div class="ledger-stat-value">
                {{ deductionPaymentSummary.sss }}
              </div>
            </div>
          </CCol>
          <CCol cols="6" sm="4" lg="2" class="mb-2">
            <div class="ledger-stat-card">
              <div class="ledger-stat-label">Pag-IBIG loan payment</div>
              <div class="ledger-stat-value">
                {{ deductionPaymentSummary.pagibig }}
              </div>
            </div>
          </CCol>
          <CCol cols="6" sm="4" lg="2" class="mb-2">
            <div class="ledger-stat-card">
              <div class="ledger-stat-label">Cash advance payment</div>
              <div class="ledger-stat-value">
                {{ deductionPaymentSummary.cashAdvance }}
              </div>
            </div>
          </CCol>
          <CCol cols="6" sm="4" lg="2" class="mb-2">
            <div class="ledger-stat-card">
              <div class="ledger-stat-label">Other deductions payment</div>
              <div class="ledger-stat-value">
                {{ deductionPaymentSummary.other }}
              </div>
            </div>
          </CCol>
             <CCol cols="6" sm="4" lg="2" class="mb-2">
            <div class="ledger-stat-card ledger-stat-card--payment-total">
              <div class="ledger-stat-label">Total payment</div>
              <div class="ledger-stat-value ledger-stat-value--payment-total">
                {{ deductionPaymentSummary.total }}
              </div>
            </div>
          </CCol>
        </CRow>
        <div class="ledger-section-head">
          <div class="d-flex align-items-center flex-wrap">
            <span class="ledger-section-title">Deductions</span>
            <span class="ledger-count-badge ledger-count-badge--muted">{{ ledgerDeductionRows.length }}</span>
          </div>
          <div class="d-flex align-items-center flex-wrap ledger-section-head-actions">
            <!-- <span class="ledger-section-total ledger-section-total--deductions mr-md-2 mb-2 mb-md-0">
              {{ deductionsTotalFormatted }}
            </span> -->
            <CButton
              v-if="config.getPermission('personnel_ledger').create"
              size="sm"
              color="danger"
              class="ledger-section-action-btn"
              @click="adddDeduction()"
            >
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>
              Add deduction
            </CButton>
          </div>
        </div>
        <div class="table-responsive-sm table-responsive-md ledger-table-wrap">
          <CDataTable
            pagination
            :loading="isLoadingDeductions"
            :items="ledgerDeductionRows"
            :fields="fieldsDeductions"
            hover
            outlined
            itemsperPage="10"
            itemsPerPageSelect
            class="ledger-data-table"
          >
            <template #entry_type="{ item }">
              <td class="align-middle">
                <CBadge class="ledger-type-badge" :color="entryTypeBadgeColor(item.entry_type_holder)">
                  {{ item.entry_type }}
                </CBadge>
              </td>
            </template>
            <template #amount="{ item }">
              <td class="align-middle font-weight-bold ledger-amount-deducted">
                {{ deductionAmountDisplay(item) }}
              </td>
            </template>
            <template #action="{ item }">
              <td class="align-middle ledger-action-cell" style="min-width: 6rem">
                <CDropdown
                  v-if="hasLedgerRowActionsPermission"
                  toggler-text="Select"
                  size="sm"
                  color="secondary"
                  class="ledger-row-actions"
                  placement="bottom-end"
                  :custom-popper-options="ledgerActionDropdownPopperOptions"
                  add-menu-classes="dropdown-menu-right"
                >
                  <CDropdownItem
                    v-if="config.getPermission('personnel_ledger').update"
                    :disabled="hasPayrollReference(item)"
                    @click="updateModal(item)"
                  >
                    <i class="fa fa-pencil-square-o mr-1" aria-hidden="true"></i>
                    Update
                  </CDropdownItem>
                  <CDropdownItem
                    v-if="config.getPermission('personnel_ledger').delete"
                    :disabled="hasPayrollReference(item)"
                    @click="deleteItem(item)"
                  >
                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                    Delete
                  </CDropdownItem>
                </CDropdown>
              </td>
            </template>
          </CDataTable>
        </div>
      </CCardBody>
    </CCard>
    <!-- ADD ENTRY-->
    <CModal
      :title="title"
      :show.sync="formModal"
      @close="closeModal()"
      color="info"
      size="lg"
     
    >
      <form @submit.prevent="submit">
        
          <CRow>
            <CCol class="col-md-12" v-if="!canCashAdvance">
              <div class="alert alert-warning" role="alert">
                    <h4><i class="fa fa-warning"></i> Cash advance transaction warning!</h4>
                    <small class="mb-0">
                        <em>This personnel has less than {{ '3000' | number_format('currency') }} salary for the last 14 days. 
                        </em>
                     </small>
                    <hr class="my-1">
                    <small>Computed salary from {{ salary_start_date }} to {{ salary_end_date }} : <strong>{{ salary | number_format('currency') }}</strong></small>
                </div>
            </CCol>
            <CCol class="col-md-12" v-if="caHasError">
              <div class="alert alert-danger" role="alert">
                   <h5><i class="fa fa-warning"></i> Warning! The maximum allowable amount has been consumed.</h5>
                  
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="col-md-12">
              <div class="form-group">
                <small for="entry_type"
                  >Type<span class="text-danger"> *</span>
              </small>
                <CInputRadioGroup
                  :options="[
                    {
                      value: 'cash_advance',
                      label: 'Cash Advance',
                      // props: { required: 'true', disabled : !this.canCashAdvance }  <!-- Gusto nila warning nlng daw. Maka cash advance jpn bsan less than 3k iyang computed salary for last 14 days -->
                      props: { required: 'true'}
                    },
                    {
                      value: 'charges',
                      label: 'Charges',
                      props: { required: 'true' }
                    },
                    {
                      value: 'sss_loan',
                      label: 'SSS Loan',
                      props: { required: 'true' }
                    },
                    {
                      value: 'pagibig_loan',
                      label: 'Pag-ibig Loan',
                      props: { required: 'true' }
                    },
                    {
                      value: 'other_deductions',
                      label: 'Other Deductions',
                      props: { required: 'true' }
                    },
                  ]"
                  :checked.sync="personnelLedgerParam.entry_type"
                  :inline="true"
                  required="true"
                  class="mb-2"
                />
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="12" >
              <small
                >Amount
                <span class="text-danger">* </span>
                <!-- <strong class="float-right" v-if="personnelLedgerParam.entry_type == 'cash_advance'">
                  Allowable amount: <span class="text-danger">{{ computeAllowedCA | number_format('currency') }}</span>
                </strong> -->
              </small>
              <CInput type="text" v-model="personnelLedgerParam.amount" 
              @keypress="isNumber($event)"
              class="mb-0"
              :class="{ 'has-error': entryUpdateHasError }"
              required="true"/>
              <div v-if="isEntryUpdate && entryUpdateValidation.hasPayments" class="mt-2">
                <small class="text-muted d-block">
                  Current {{ entryUpdateValidation.typeLabel }} balance:
                  <strong>{{ entryUpdateValidation.currentBalanceFormatted }}</strong>
                  · Total payments:
                  <strong>{{ entryUpdateValidation.paymentsFormatted }}</strong>
                </small>
                <small
                  v-if="entryUpdateHasError"
                  class="text-danger d-block mt-1"
                >
                  Updated amount would make {{ entryUpdateValidation.typeLabel }} balance negative
                  (projected: {{ entryUpdateValidation.projectedBalanceFormatted }}).
                  Minimum amount for this entry:
                  {{ entryUpdateValidation.minimumAmountFormatted }}.
                </small>
              </div>
            </CCol>
          </CRow>
            <!-- Gusto nila warning nlng daw. Maka cash advance jpn bsan lampas nag 2k -->
            <!-- <CCol lg="12" >
              <small
                >Amount
                <span class="text-danger">* </span>
                <strong class="float-right" v-if="personnelLedgerParam.entry_type == 'cash_advance'">
                  Allowable amount: <span class="text-danger">{{ computeAllowedCA | number_format('currency') }}</span>
                </strong>
              </small>
              <CInput type="text" v-model="personnelLedgerParam.amount" 
              @keypress="isNumber($event)"
              class="mb-0" 
              :class="{'has-error' : caHasError} "
              required="true"/>
              <div v-show="caHasError" >
                <small class="text-danger">
                  Amount should not be greater than the allowable amount.
                </small>
               </div>
            </CCol>
          </CRow> -->


          <CRow>
            <CCol lg="12">
              <small
                >Date
                <span class="text-danger">* </span></small >
              <Datepicker
                input-class="form-control bg-white"
                :typeable="true" 
                class="mb-2"  
                v-model="personnelLedgerParam.entry_date"
                required
              >
              </Datepicker>
            </CCol>
          </CRow>

          <CRow>
            <CCol lg="12">
              <small class="mr-2">Remarks</small>
              <textarea
                :disabled="is_disabled"
                class="form-control mb-2"
                v-model="personnelLedgerParam.remarks"
              ></textarea>
            </CCol>
          </CRow>
      
        <div slot="footer" class="w-100 mt-3">
        
          <template>
            <CButton
              v-if="!entryUpdateHasError"
              type="submit"
              style="border-radius: 0.2rem; color: white"
              color="info"
              class="ml-1 mr-1 float-right"
              size="sm"
            >
              Save
            </CButton>
            <a
              v-else
              href="javascript:;"
              class="btn btn-sm btn-info disabled ml-1 mr-1 float-right"
            >Save</a>
          </template>
          <CButton
            style="border-radius: 0.2rem; color: white"
            color="danger"
            class="ml-1 mr-1 float-right"
            @click="closeModal()"
            size="sm"
          >
            Cancel
          </CButton>
        </div>
      </form>
      <div slot="footer" class="w-100"></div>
    </CModal>

    <!-- DEDUCTION -->
    <CModal
      :title="title"
      :show.sync="deductionModal"
      @close="closeModal()"
      color="info"
      size="lg"
      
    >
      <form @submit.prevent="submit">
     
          <CRow>
            <CCol class="col-md-12">
              <div class="form-group">
                <label style="font-size: 12px;" for="charges_type"
                  >Type<span class="text-danger"> *</span>
                </label>
                <CInputRadioGroup
                  :options="[
                    {
                      value: 'cash_advance',
                      label: 'Cash Advance',
                      props: { required: 'true' }
                    },
                    {
                      value: 'charges',
                      label: 'Charges',
                      props: { required: 'true' }
                    },
                    {
                      value: 'sss_loan',
                      label: 'SSS Loan',
                      props: { required: 'true' }
                    },
                    {
                      value: 'pagibig_loan',
                      label: 'Pag-ibig Loan',
                      props: { required: 'true' }
                    },
                    {
                      value: 'other_deductions',
                      label: 'Other Deductions',
                      props: { required: 'true' }
                    },
                  ]"
                  :checked.sync="personnelLedgerParam.entry_type"
                  :inline="true"
                  required="true"
                  
                />
              </div>
            </CCol>
          </CRow>
          
				<CRow>
				
				
				</CRow>
				
          <CRow>
            <CCol lg="12">
              <div class="form-group">
              <label style="font-size: 12px;"
                >Deduction Amount
                <span class="text-danger">* </span></label>
              <CInput type="text" v-model="personnelLedgerParam.amount"
                @keypress="isNumber($event)" 
                required="true" class="mb-0" :class="{'has-error' : hasError}"/>
              <div v-show="hasError">
                <small class="text-danger" v-if="personnelLedgerParam.entry_type == 'cash_advance'">
                  Deduction amount should not be greater than with cash advance balance.
                </small>
                <small class="text-danger" v-if="personnelLedgerParam.entry_type == 'charges'">
                  Deduction amount should not be greater than with charges balance.
                </small>
                <small class="text-danger" v-if="personnelLedgerParam.entry_type == 'sss_loan'">
                  Deduction amount should not be greater than with sss loan balance.
                </small>
                <small class="text-danger" v-if="personnelLedgerParam.entry_type == 'pagibig_loan'">
                  Deduction amount should not be greater than with pagibig loan balance.
                </small>
                <small class="text-danger" v-if="personnelLedgerParam.entry_type == 'other_deductions'">
                  Deduction amount should not be greater than with other deduction balance.
                </small>

              </div>
              <!-- <small class="text-danger" v-show="hasError">
                {{ personnelLedgerParam.entry_type == 'cash_advance' ? 'Cash advance' : 'Charges' }}
                 deduction amount should not be greater than with the balance.</small> -->
            </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="12">
              <small
                >Date
                <span class="text-danger">* </span></small >
              <Datepicker
                input-class="form-control bg-white"
                :typeable="true" 
                class="mb-2"  
                v-model="personnelLedgerParam.entry_date"
                required
              >
              </Datepicker>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="12">
              <div class="form-group">
              <label style="font-size: 12px;">Remarks</label>
              <textarea
                class="form-control"
                v-model="personnelLedgerParam.remarks"
              ></textarea>
            </div>
            </CCol>
          </CRow>
      
        <div slot="footer" class="w-100 mt-3">
         
          <template >
            <CButton
              type="submit"
              style="border-radius: 0.2rem; color: white"
              color="info"
              class="ml-1 mr-1 float-right"
              size="sm"
              v-if="!hasError"
            >
              Save
            </CButton>
            <a href="javascript:;" class="btn btn-sm btn-info disabled ml-1 mr-1 float-right" v-else>Save</a>
            
          </template>
          <CButton
            style="border-radius: 0.2rem; color: white"
            color="danger"
            class="ml-1 mr-1 float-right"
            @click="closeModal()"
            size="sm"
          >
            Close
          </CButton>
        </div>
      </form>
      <div slot="footer" class="w-100"></div>
    </CModal>
  </div>
</template>
<script>
import config from "../../config.js";
import axios from "../../axios";
import Swal from "sweetalert2";
import Search from "./search";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  mounted() {
    // this.getEntryListFilter();
    this.defaultDateFrom();
    this.getEntryList();
    this.getPersonnel();
    this.getLedgerInfo();        
  },
  filters: {
    formatDate(val) {
      if (val) return moment.unix(val).format("MMMM DD, YYYY");
      return "";
    },
  },
  watch: {
    
    
  },
  computed: {
    canCashAdvance() {
      if(this.salary < 3000) {
        return false;
      }
      return true;
    },
    computeAllowedCA() {
        let balance = this.dataLedgerInfo[0].personnel_ledger_CAB ?? 0;
        return 2000 - balance;
    },
    is_disabled() {
      return this.mode.view;
    },
    checkFilter() {
      return this.dataParams.asset_type;
    },
    caHasError() {
      if (this.personnelLedgerParam.entry_type != 'cash_advance') return false;

      let inputted = this.personnelLedgerParam.amount ?? 0;
      if(parseFloat(inputted) > parseFloat(this.computeAllowedCA)) {
        return true;
      }

      return false;
    },
    hasError() {
        let type = this.personnelLedgerParam.entry_type;
        let inputted = this.personnelLedgerParam.amount ?? 0;
        let balance = 0;
        
        if(!this.dataLedgerInfo.length) return false;

        if(type == 'cash_advance') { //cash advance
          balance = this.dataLedgerInfo[0].personnel_ledger_CAB ?? 0;
          if(parseFloat(inputted) > parseFloat(balance)) {
            return true;
          }

          return false;
        }
        else if(type == 'charges') { //charges
          balance = this.dataLedgerInfo[0].personnel_ledger_CB ?? 0;
          if(parseFloat(inputted) > parseFloat(balance)) {
            return true;
          }
          return false;
        }
        else if(type == 'pagibig_loan') { //pagibig
          balance = this.dataLedgerInfo[0].personnel_ledger_PagibigBalance ?? 0;
          if(parseFloat(inputted) > parseFloat(balance)) {
            return true;
          }
          return false;
        }
        else if(type == 'sss_loan') { //sss loan
          balance = this.dataLedgerInfo[0].personnel_ledger_SSSBalance ?? 0;
          if(parseFloat(inputted) > parseFloat(balance)) {
            return true;
          }
          return false;
        }
        else if(type == 'other_deductions') { //other deduction
          balance = this.dataLedgerInfo[0].personnel_ledger_OtherDeductionsBalance ?? 0;
          if(parseFloat(inputted) > parseFloat(balance)) {
            return true;
          }
          return false;
        }
        return false;
    },
    isEntryUpdate() {
      return !!this.personnelLedgerParam.id && !this.deductionModal;
    },
    entryUpdateValidation() {
      const empty = {
        hasError: false,
        hasPayments: false,
        typeLabel: "",
        currentBalanceFormatted: "",
        paymentsFormatted: "",
        projectedBalanceFormatted: "",
        minimumAmountFormatted: "",
      };
      if (!this.isEntryUpdate || !this.dataLedgerInfo.length) {
        return empty;
      }

      const typeMap = {
        cash_advance: {
          label: "Cash Advance",
          balanceKey: "personnel_ledger_CAB",
          paymentKey: "ca_deduc_sum",
        },
        charges: {
          label: "Charges",
          balanceKey: "personnel_ledger_CB",
          paymentKey: "ch_deduc_sum",
        },
        sss_loan: {
          label: "SSS Loan",
          balanceKey: "personnel_ledger_SSSBalance",
          paymentKey: "sss_deduc_sum",
        },
        pagibig_loan: {
          label: "Pag-ibig Loan",
          balanceKey: "personnel_ledger_PagibigBalance",
          paymentKey: "pagibig_deduc_sum",
        },
        other_deductions: {
          label: "Other Deductions",
          balanceKey: "personnel_ledger_OtherDeductionsBalance",
          paymentKey: "otherdeductions_deduc_sum",
        },
      };

      const type = this.personnelLedgerParam.entry_type;
      const cfg = typeMap[type];
      if (!cfg) return empty;

      const item = this.dataLedgerInfo[0];
      const n = (v) =>
        parseFloat(String(v != null ? v : 0).replace(/,/g, "")) || 0;
      const fmt = (v) =>
        this.$options.filters.number_format(v, "currency", 2);

      const payments = n(item[cfg.paymentKey]);
      if (payments <= 0) {
        return empty;
      }

      const currentBalance = n(item[cfg.balanceKey]);
      const oldAmount = n(this.originalEntryAmount);
      const newAmount = n(this.personnelLedgerParam.amount);
      const projectedBalance = currentBalance - oldAmount + newAmount;
      const minimumAmount = Math.max(0, oldAmount - currentBalance);

      return {
        hasError: projectedBalance < 0,
        hasPayments: true,
        typeLabel: cfg.label,
        currentBalanceFormatted: fmt(currentBalance),
        paymentsFormatted: fmt(payments),
        projectedBalanceFormatted: fmt(projectedBalance),
        minimumAmountFormatted: fmt(minimumAmount),
      };
    },
    entryUpdateHasError() {
      return this.entryUpdateValidation.hasError;
    },
    ledgerProfile() {
      const item = this.dataLedgerInfo[0];
      if (!item) return { name: "" };
      return { name: item.employee_name || "" };
    },
    rowsAfterTypeFilter() {
      let rows = [...(this.dataListHolder || [])];
      if (this.dataParams.entry_type && this.dataParams.entry_type !== "all") {
        rows = rows.filter((r) => r.entry_type_holder === this.dataParams.entry_type);
      }
      return rows;
    },
    deductionRowsAfterTypeFilter() {
      let rows = [...(this.deductionListHolder || [])];
      if (this.dataParams.entry_type && this.dataParams.entry_type !== "all") {
        rows = rows.filter((r) => r.entry_type_holder === this.dataParams.entry_type);
      }
      return rows;
    },
    ledgerEntryRows() {
      const q = (this.searchQuery || "").trim().toLowerCase();
      return this.rowsAfterTypeFilter
        .filter((item) => !this.rowIsDeduction(item))
        .filter((item) => this.matchesSearch(item, q));
    },
    ledgerDeductionRows() {
      const q = (this.searchQuery || "").trim().toLowerCase();
      return this.deductionRowsAfterTypeFilter.filter((item) => this.matchesSearch(item, q));
    },
    entriesTotalValue() {
      return this.ledgerEntryRows.reduce((sum, r) => sum + (Number(r.amountNumeric) || 0), 0);
    },
    deductionsTotalValue() {
      return this.ledgerDeductionRows.reduce((sum, r) => sum + (Number(r.amountNumeric) || 0), 0);
    },
    entriesTotalFormatted() {
      return this.formatSignedCurrency(this.entriesTotalValue, "entries");
    },
    deductionsTotalFormatted() {
      return this.formatSignedCurrency(this.deductionsTotalValue, "deductions");
    },
    deductionPaymentSummary() {
      const item = this.dataLedgerInfo[0];
      const fmt = (v) =>
        this.$options.filters.number_format(
          parseFloat(String(v != null ? v : 0).replace(/,/g, "")) || 0,
          "currency",
          2
        );
      const n = (v) => parseFloat(String(v != null ? v : 0).replace(/,/g, "")) || 0;
      if (!item) {
        return {
          total: fmt(0),
          charges: fmt(0),
          sss: fmt(0),
          pagibig: fmt(0),
          cashAdvance: fmt(0),
          other: fmt(0),
        };
      }
      const ca = n(item.ca_deduc_sum);
      const ch = n(item.ch_deduc_sum);
      const sss = n(item.sss_deduc_sum);
      const pag = n(item.pagibig_deduc_sum);
      const other = n(item.otherdeductions_deduc_sum);
      const sumParts = ca + ch + sss + pag + other;
      let total = sumParts;
      if (item.total_payment != null && item.total_payment !== "") {
        total = n(item.total_payment);
      } else if (
        item.total_deduction_payment != null &&
        item.total_deduction_payment !== ""
      ) {
        total = n(item.total_deduction_payment);
      }
      return {
        total: fmt(total),
        charges: fmt(item.ch_deduc_sum),
        sss: fmt(item.sss_deduc_sum),
        pagibig: fmt(item.pagibig_deduc_sum),
        cashAdvance: fmt(item.ca_deduc_sum),
        other: fmt(item.otherdeductions_deduc_sum),
      };
    },
    ledgerActionDropdownPopperOptions() {
      return {
        placement: "bottom-end",
        strategy: "fixed",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", enabled: true },
          {
            name: "preventOverflow",
            options: {
              padding: 10,
              boundary: "viewport",
            },
          },
        ],
      };
    },
    hasLedgerRowActionsPermission() {
      const p = this.config.getPermission("personnel_ledger");
      return !!(p && (p.update || p.delete));
    },
  },
  data() {
    return {
      title: '',
      charge_date_to:null,
      charge_date_from:null,
      flag: 0,
      isLoading: false,
      isLoadingDeductions: false,
      config,      
      dataParams: {
        entry_type: "all",
      },
      formModal: false,
      deductionModal: false,
      dataLedgerInfo: [],
      dataList: [],
      depotName: "",
      fields: [
        {
          key: "entry_type",
          label: "Type",
        },
        {
          key: "amount",
          label: "Amount",
        },
        {
          key: "entry_date",
          label: "Date",
        },

        {
          key: "remarks",
          label: "Remarks",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      fieldsDeductions: [
        { key: "entry_type", label: "Type" },
        { key: "amount", label: "Amount deducted" },
        { key: "entry_date", label: "Date" },
        { key: "remarks", label: "Remarks" },
        { key: "action", label: "Action" },
      ],
      entryTypeTabs: [
        { value: "all", label: "All" },
        { value: "charges", label: "Charges" },
        { value: "cash_advance", label: "Cash advance" },
        { value: "pagibig_loan", label: "Pag-ibig loan" },
        { value: "sss_loan", label: "SSS loan" },
        { value: "other_deductions", label: "Other deductions" },
      ],
      searchQuery: "",
      currentPage: 1,
      selectedRow: {},
      showCollapse: false,
      limit:10,
      filter: {
        adjustment_id: "",
        booking_no: "",
        plate_no: "",
        destination: "",
        personnel_id: "",
        delivery_date_from: "",
        delivery_date_to: "",
        status: "",
      },

      personnelList: {
        data: [],
      },

      showViewModal: false,
     
      personnelLedgerParam: {
        entry_type : "",
        remarks: null,        
		    entry_date: null,
		    amount: null,
        is_deduction: null,
        id: null,
      },
      mode: {
        view: false,
        new: true,
        edit: false,
      },
      dataListHolder: [],
      deductionListHolder: [],
      date_from : null,
      date_to: null,
      salary : 0,
      salary_start_date: null,
      salary_end_date : null,
      originalEntryAmount: 0,
    };
  },
  name: "Tables",
  components: { Search, Datepicker, vSelect },
  methods: {
    normalizeLedgerRemarks(value) {
      if (value == null) return "";
      const text = String(value).trim();
      if (!text) return "";
      if (!text.includes("|")) return text;

      const segments = text
        .split("|")
        .map((part) => part.trim())
        .filter(Boolean);

      if (!segments.length) return "";

      const seen = new Set();
      const deduped = [];
      segments.forEach((segment) => {
        if (!seen.has(segment)) {
          seen.add(segment);
          deduped.push(segment);
        }
      });

      return deduped.join(" | ");
    },
    rowIsDeduction(item) {
      if (!item) return false;
      return (
        item.is_deduction_row === true ||
        item.is_deduction === 1 ||
        item.is_deduction === "1" ||
        item.is_deduction === true
      );
    },
    matchesSearch(item, q) {
      if (!q) return true;
      const blob = [item.entry_type, item.amount, item.entry_date, item.remarks]
        .map((x) => (x != null ? String(x) : ""))
        .join(" ")
        .toLowerCase();
      return blob.includes(q);
    },
    formatSignedCurrency(value, kind) {
      const n = Number(value) || 0;
      const zero = this.$options.filters.number_format(0, "currency", 2);
      if (n === 0) return zero;
      const formatted = this.$options.filters.number_format(Math.abs(n), "currency", 2);
      if (kind === "entries") {
        return formatted;
      }
      return (n > 0 ? "+" : "-") + formatted;
    },
    entryTypeBadgeColor(holder) {
      const map = {
        charges: "warning",
        cash_advance: "info",
        sss_loan: "success",
        pagibig_loan: "primary",
        other_deductions: "dark",
      };
      return map[holder] || "secondary";
    },
    ledgerAvatarInitials(item) {
      return this.initialsFromName(item && item.employee_name);
    },
    initialsFromName(name) {
      if (!name || !String(name).trim()) return "--";
      const s = String(name).trim();
      const parts = s.split(",").map((p) => p.trim()).filter(Boolean);
      if (parts.length >= 2 && parts[0] && parts[1]) {
        return (parts[1][0] + parts[0][0]).toUpperCase();
      }
      const words = s.split(/\s+/).filter(Boolean);
      if (words.length >= 2) {
        return (words[0][0] + words[words.length - 1][0]).toUpperCase();
      }
      return s.slice(0, 2).toUpperCase();
    },
    entryAmountDisplay(item) {
      if (!item || item.amount == null || item.amount === "") return "";
      return String(item.amount).trim().replace(/^-\s*/, "");
    },
    deductionAmountDisplay(item) {
      if (!item || item.amount == null || item.amount === "") return "";
      const str = String(item.amount).trim();
      if (str.startsWith("-")) return str;
      return "-" + str;
    },
    hasPayrollReference(item) {
      if (!item) return false;
      const hasValue = (value) => {
        if (value === null || value === undefined) return false;
        const normalized = String(value).trim().toLowerCase();
        return normalized !== "" && normalized !== "null" && normalized !== "undefined";
      };
      const hasConsumedByPayrollId =
        hasValue(item.consumed_by_payroll_id);
      const hasPayrollId =
        hasValue(item.payroll_id);
      return hasConsumedByPayrollId || hasPayrollId;
    },
    statusBadgeColor(status) {
      const s = (status || "").toString().trim().toLowerCase();
      if (s === "active") return "success";
      if (s === "inactive" || s === "resigned" || s === "terminated") return "secondary";
      return "info";
    },
    getLedgerInfo() {
      
      this.$showLoading(true)      
      axios.get(config.api_path+'/ledger/list/info',{
				params : {
					id : this.$route.params.id
				}
			}).then((res) => {
        const {data, salary, start_date, end_date} = res.data;
        this.$showLoading(false)  
          this.dataLedgerInfo = data;   
          this.salary = salary ?? 0;    
          this.salary_start_date = start_date;
          this.salary_end_date = end_date;                      
        })
        .catch(err => {
			this.$showLoading(false)
		}) 
    },
    download() {
			this.$showLoading(true)
			axios.get(config.api_path+'/ledger/view_download',{
				params: {id : this.$route.params.id}
			}).then(response => {
        console.log(response)
				this.$showLoading(false)
				window.open(config.main_path.replace('/index.php', '')+'/'+response.data.file) 

					setTimeout(() => {
						axios.get(`${config.api_path}/remove-file`,{
							params : {
								filename : response.data.file
							}
						})	
					}, 2000);
				
			}).catch(err => {
				this.$showLoading(false)
			})
		},
		
   
  //add ledger entry
     // axios.post(config.api_path+'/ledger/process',{
    //   flag: 0, // 0 insert, 1 update, 2 delete
    //   type : 'CHARGES',
    //   amount : 50,
    //   date : '2022-09-28',
    //   remarks : 'deduct',
    //   is_deduction : 1,
    //   personnel_id : this.$route.params.id,
    //   id : null
    // })
    buildLedgerBalancesHtml() {
      const item = this.dataLedgerInfo[0];
      if (!item) return "";
      const n = (v) =>
        parseFloat(String(v != null ? v : 0).replace(/,/g, "")) || 0;
      const fmt = (v) =>
        this.$options.filters.number_format(v, "currency", 2);
      const rows = [
        ["Cash Advance", n(item.personnel_ledger_CAB)],
        ["Charges", n(item.personnel_ledger_CB)],
        ["SSS Loan", n(item.personnel_ledger_SSSBalance)],
        ["Pag-ibig Loan", n(item.personnel_ledger_PagibigBalance)],
        ["Other Deductions", n(item.personnel_ledger_OtherDeductionsBalance)],
      ];
      return (
        '<ul style="text-align:left;margin:0.5rem 0 0;padding-left:1.2em;">' +
        rows
          .map(([label, val]) => {
            const style =
              val < 0 ? ' style="color:#e55353;font-weight:bold;"' : "";
            return `<li${style}>${label}: ${fmt(val)}</li>`;
          })
          .join("") +
        "</ul>"
      );
    },
    submit() {
      if (
        this.personnelLedgerParam.amount == null ||
        this.personnelLedgerParam.entry_date == null
      ) {
        Swal.fire({
          title: "warning",
          text: "Please fill out the fields.",
          icon: "warning",
        });
        return;
      }

      if (this.deductionModal && this.hasError) {
        return;
      }

      if (this.entryUpdateHasError) {
        const v = this.entryUpdateValidation;
        Swal.fire({
          title: "Cannot update entry",
          html:
            `<p>Updating this <strong>${v.typeLabel}</strong> entry would make the balance negative.</p>` +
            `<p><strong>Current balances:</strong></p>` +
            this.buildLedgerBalancesHtml() +
            `<p>Minimum amount for this entry: <strong>${v.minimumAmountFormatted}</strong></p>`,
          icon: "warning",
        });
        return;
      }

      this.$showLoading(true);
      const isDeductionValue = this.deductionModal
        ? 1
        : this.personnelLedgerParam.is_deduction;
      const isUpdate = this.personnelLedgerParam.id != null;

      axios
        .post(config.api_path + "/ledger/process", {
          flag: isUpdate ? 1 : 0,
          type: this.personnelLedgerParam.entry_type,
          amount: this.personnelLedgerParam.amount,
          date: moment(this.personnelLedgerParam.entry_date).format("y-M-D"),
          remarks: this.personnelLedgerParam?.remarks ?? null,
          is_deduction: isDeductionValue,
          personnel_id: this.$route.params.id,
          id: this.personnelLedgerParam.id,
        })
        .then(() => {
          this.$showLoading(false);
          this.formModal = false;
          this.deductionModal = false;
          this.getEntryList();
          this.getLedgerInfo();
          this.ResetLedgerParam();
          Swal.fire({
            title: "Success",
            text: isUpdate
              ? "Entry successfully updated."
              : "Entry successfully added.",
            icon: "success",
          });
        })
        .catch(() => {
          this.$showLoading(false);
        });
    },

    addModal() {
      this.setMode("new");
      this.originalEntryAmount = 0;
      this.formModal = !this.formModal;
      this.title = "Add Entry";
    },
    adddDeduction() {
      this.setModeDeduction("new");
      this.deductionModal = !this.deductionModal;
      this.title = "Deduction";
      this.personnelLedgerParam.is_deduction = 1;     
    },
    updateModal(item){
      if (this.hasPayrollReference(item)) return;
      console.log(item);
      this.title = "Update Entry";
      this.selectedRow = item;
      this.originalEntryAmount =
        item.amountNumeric != null
          ? item.amountNumeric
          : parseFloat(String(item.amount || "").replace(/,/g, "")) || 0;
      this.personnelLedgerParam = {...item};
      const isDeductionRow = this.rowIsDeduction(item);
      this.personnelLedgerParam.is_deduction = isDeductionRow ? 1 : null;
      switch (this.personnelLedgerParam.entry_type) {
        case 'Charges':
              this.personnelLedgerParam.entry_type = 'charges';
        break;
        case 'Cash Advance':
              this.personnelLedgerParam.entry_type = 'cash_advance';
        break;
        case 'SSS Loan':
              this.personnelLedgerParam.entry_type = 'sss_loan';
        break;
        case 'Pagibig Loan':
              this.personnelLedgerParam.entry_type = 'pagibig_loan';
        break;
        case 'Other Deductions':
              this.personnelLedgerParam.entry_type = 'other_deductions';
        break;
      
       
      }
      // if(this.personnelLedgerParam.entry_type == "Charges") {
      //   this.personnelLedgerParam.entry_type = 'charges';
      // } else {
      //   this.personnelLedgerParam.entry_type = 'cash_advance';
      // }
      this.formModal = !isDeductionRow;
      this.deductionModal = isDeductionRow;                 
    },
   
    setModeDeduction(type) {
      this.mode = {
        view: false,
        edit: false,
        new: false,
      };
      this.mode[type] = true;
    },
    setMode(type) {
      this.mode = {
        view: false,
        edit: false,
        new: false,
      };
      this.mode[type] = true;
    },
    
    viewPayment() {
    // this.$router.push('/data/odometer/'+this.$route.params.id)
		window.open(`#/main/view_personnel_payment/${this.$route.params.id}`, '_blank');
	},
	
  
   
    closeModal() {
      console.log("oyet");
      this.formModal = false;
      this.deductionModal = false;
      this.reloadData();
      this.ResetLedgerParam();
    },
    reloadData() {
      this.getEntryList();
    },
    updatePage(data) {
      this.currentPage = data;
      this.getEntryList();
    },

    // search(event) {
    //   this.filter = event;
    //   this.getEntryList();
    // },

    ResetLedgerParam() {
      this.personnelLedgerParam.entry_type = "";
      this.personnelLedgerParam.amount = "";
      this.personnelLedgerParam.entry_date = null;
      this.personnelLedgerParam.is_deduction = null;
      this.personnelLedgerParam.remarks = "";
      this.personnelLedgerParam.id = null;
      this.originalEntryAmount = 0;
    },
   
    getPersonnel() {
      axios
        .get(config.api_path + "/reference/personnel-list")
        .then((response) => {
          this.personnelList = response.data;
        });
    },
    extractLedgerListRows(response) {
      if (!response || response.data == null) return [];
      const body = response.data;
      if (Array.isArray(body)) return body;
      if (body.data && Array.isArray(body.data)) return body.data;
      return [];
    },
    mapLedgerRow(item, fromDeductionList) {
      const rawAmount = item.amount;
      const amountNumeric =
        parseFloat(String(rawAmount != null ? rawAmount : "").replace(/,/g, "")) || 0;
      const is_deduction_row = fromDeductionList
        ? true
        : item.is_deduction === 1 ||
          item.is_deduction === "1" ||
          item.is_deduction === true;

      const rawType = item.entry_type || item.type;
      const typeCode =
        typeof rawType === "string"
          ? rawType.trim().toLowerCase().replace(/\s+/g, "_")
          : rawType;
      item.entry_type_holder = typeCode || rawType;
      if (!item.type && item.entry_type_holder) {
        item.type = item.entry_type_holder;
      }

      const dateRaw = item.date || item.entry_date;
      if (dateRaw) {
        item.date = dateRaw;
      }
      item.entry_date = dateRaw ? moment(dateRaw).format("MM/DD/YYYY") : "";

      switch (typeCode) {
        case "charges":
          item.entry_type = "Charges";
          break;
        case "cash_advance":
          item.entry_type = "Cash Advance";
          break;
        case "pagibig_loan":
          item.entry_type = "Pag-ibig Loan";
          break;
        case "sss_loan":
          item.entry_type = "SSS Loan";
          break;
        case "other_deductions":
          item.entry_type = "Other Deductions";
          break;
        default:
          if (typeof rawType === "string" && rawType.trim()) {
            item.entry_type = rawType;
          }
          break;
      }
      item.amountNumeric = amountNumeric;
      item.is_deduction_row = is_deduction_row;
      item.is_deduction = is_deduction_row ? 1 : item.is_deduction;
      item.remarks = this.normalizeLedgerRemarks(item.remarks);
      item.amount = rawAmount
        ? this.$options.filters.number_format(rawAmount, "", 2)
        : "";
      return item;
    },
    getEntryList() {
      this.$showLoading(true);
      this.isLoading = true;
      this.isLoadingDeductions = true;

      const params = {
        personnel_id: this.$route.params.id,
        date_from: moment(this.date_from).format("y-M-D"),
        date_to: moment(this.date_to).format("y-M-D"),
      };

      const detailPromise = axios
        .get(config.api_path + "/ledger/personnel/detail", { params })
        .then((response) => {
          this.dataList = response.data;
          const source =
            this.dataList && this.dataList.data ? this.dataList.data : [];
          const mapped = source.map((row) => this.mapLedgerRow(row, false));
          this.dataList.data = mapped;
          this.dataListHolder = mapped;
        })
        .catch(() => {
          this.dataList = { data: [] };
          this.dataListHolder = [];
        });

      const deductionPromise = axios
        .get(config.api_path + "/ledger/deduction-list", { params })
        .then((response) => {
          const rows = this.extractLedgerListRows(response);
          this.deductionListHolder = rows.map((row) => this.mapLedgerRow(row, true));
        })
        .catch(() => {
          this.deductionListHolder = [];
        });

      Promise.allSettled([detailPromise, deductionPromise]).finally(() => {
        this.$showLoading(false);
        this.isLoading = false;
        this.isLoadingDeductions = false;
      });
    },
    // getEntryListFilter() {      
    //   axios.get(config.api_path+'/ledger/personnel/detail',{
    //   params : {
    //     personnel_id : this.$route.params.id,
    //     entry_type : this.dataParams.asset_type,
    //   }
    // }).then((response) => {
    //     this.dataList = response.data;
    //     this.dataList.data.filter(function(item){return this.dataParams.asset_type == item.entry_type});
                 
    // });      
    // },
    filterList() {
      this.getEntryList()
    },
    defaultDateFrom(){          
      var date = new Date();
      this.date_to = this.date = moment(date).format('DD MMM YYYY');
      date.setDate(date.getDate() - 30);
      this.date_from = this.date = moment(date).format('DD MMM YYYY');
      this.filterList();
    },
    deleteItem(item) {
      if (this.hasPayrollReference(item)) return;
      Swal.fire({
        icon: "warning",
        text: "Are you sure you want to delete this entry ?",
        confirmButtonText: `Yes, Delete.`,
        confirmButtonColor : 'red',
        reverseButtons: true,
        showCancelButton: true
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(config.api_path+'/ledger/process',{
            flag: 2, // 0 insert, 1 update, 2 delete
            type : item.type || item.entry_type_holder,
            amount : item.amount,
            date:
              item.date || item.entry_date
                ? moment(item.date || item.entry_date).format("y-M-D")
                : null,
            remarks : item?.remarks ?? null,
            is_deduction : null,
            personnel_id : this.$route.params.id,
            id : item?.id ?? null,
            
          }).then(res => {
            this.$showLoading(false)
            this.formModal = false;
            this.getEntryList();
            this.getLedgerInfo();
            Swal.fire({
              title: 'Success',
              text: "Entry successfully deleted.",
              icon: 'success', 
            })	
          })
          .catch(err => {
            this.$showLoading(false)
          })          
        }
      });
    },
  },  
};


</script>
<style scoped>
.personnel-ledger-view {
  padding-bottom: 1rem;
}

.ledger-card {
  border-radius: 0.65rem;
}

.ledger-card--filters,
.ledger-filters-body {
  overflow: visible !important;
}

.ledger-date-wrap {
  position: relative;
  z-index: 1;
}

.ledger-date-wrap:focus-within {
  z-index: 20;
}

.personnel-ledger-view >>> .ledger-datepicker-root.vdp-datepicker,
.personnel-ledger-view >>> .vdp-datepicker {
  position: relative;
}

.personnel-ledger-view >>> .vdp-datepicker__calendar {
  z-index: 2000 !important;
}

.ledger-breadcrumb {
  letter-spacing: 0.02em;
}

.ledger-breadcrumb-sep {
  margin: 0 0.35rem;
  opacity: 0.55;
}

.ledger-toolbar-actions .btn {
  border-radius: 0.4rem;
  font-weight: 500;
}

.ledger-avatar {
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #321fdb 0%, #39f 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1rem;
  flex-shrink: 0;
}

.ledger-emp-name {
  letter-spacing: -0.01em;
}

.ledger-status-badge {
  font-size: 0.7rem;
  padding: 0.35em 0.65em;
  letter-spacing: 0.04em;
}

.ledger-stat-grid {
  margin-left: -0.35rem;
  margin-right: -0.35rem;
}

.ledger-deduction-payment-row {
  padding-top: 0.15rem;
}

.ledger-stat-card--payment-total {
  background: #e8f5e9;
  border-color: #c8e6c9;
}

.ledger-stat-card--payment-total .ledger-stat-label {
  color: #2e7d32;
}

.ledger-stat-value--payment-total {
  color: #1b5e20;
}

.ledger-stat-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.65rem 0.75rem;
  height: 100%;
  min-height: 4.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ledger-stat-card--primary {
  background: #321fdb;
  border-color: #321fdb;
}

.ledger-stat-label {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6c757d;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.ledger-stat-card--primary .ledger-stat-label {
  color: rgba(255, 255, 255, 0.85);
}

.ledger-stat-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: #212529;
  line-height: 1.25;
  word-break: break-word;
}

.ledger-stat-value--inverse {
  color: #fff;
}

.ledger-field-label {
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 0.35rem;
}

.ledger-datepicker {
  border-radius: 0.4rem;
  min-width: 9.5rem;
}

.ledger-filter-btn {
  border-radius: 0.4rem;
  font-weight: 600;
}

.ledger-search-input >>> input {
  border-radius: 0.4rem;
}

.ledger-type-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.15rem 0.35rem;
  border-bottom: 1px solid #e9ecef;
  margin: 0 -0.15rem;
  padding-bottom: 0.15rem;
}

.ledger-type-tab {
  border: none;
  background: transparent;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.5rem 0.65rem 0.65rem;
  margin: 0 0.1rem;
  border-radius: 0.35rem 0.35rem 0 0;
  cursor: pointer;
  position: relative;
  transition: color 0.15s ease, background 0.15s ease;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  box-shadow: none;
}

.ledger-type-tab:focus-visible {
  outline: 2px solid rgba(50, 31, 219, 0.45);
  outline-offset: 2px;
}

.ledger-type-tab:hover {
  color: #321fdb;
  background: rgba(50, 31, 219, 0.06);
}

.ledger-type-tab--active {
  color: #321fdb;
  font-weight: 600;
}

.ledger-type-tab--active::after {
  content: "";
  position: absolute;
  left: 0.35rem;
  right: 0.35rem;
  bottom: -1px;
  height: 2px;
  background: #321fdb;
  border-radius: 2px 2px 0 0;
}

.ledger-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  padding: 0 0.15rem;
}

.ledger-section-head-actions {
  gap: 0.5rem;
  justify-content: flex-end;
}

.ledger-section-action-btn {
  border-radius: 0.4rem;
  font-weight: 600;
  white-space: nowrap;
}

.ledger-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #495057;
}

.ledger-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.4rem;
  margin-left: 0.4rem;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 999px;
  background: #e7f1ff;
  color: #321fdb;
}

.ledger-count-badge--muted {
  background: #e9ecef;
  color: #495057;
}

.ledger-section-total {
  font-size: 1rem;
  font-weight: 700;
}

.ledger-section-total--entries {
  color: #321fdb;
}

.ledger-amount-entry {
  color: #321fdb;
}

.ledger-section-total--deductions {
  color: #2eb85c;
}

.ledger-type-badge {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.4em 0.65em;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.ledger-amount-deducted {
  color: #2eb85c;
}

.ledger-table-wrap {
  margin: 0 -0.25rem;
  overflow: visible !important;
}

.ledger-table-wrap >>> .table-responsive {
  overflow: visible !important;
}

.ledger-action-cell {
  position: relative;
  vertical-align: middle !important;
}

.ledger-row-actions {
  display: inline-block;
  text-align: right;
}

.ledger-data-table >>> .ledger-row-actions .dropdown-menu {
  min-width: 9rem;
}

.ledger-data-table >>> thead th {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6c757d;
  border-top: none;
  font-weight: 600;
}

.ledger-data-table >>> tbody td {
  vertical-align: middle;
  font-size: 0.875rem;
}
</style>
